/* eslint-disable @next/next/no-img-element */
import AppContainer from "@/components/AppContainer";
import useStyles from "./ContactUs.style";
import { useEffect, useState } from "react";
import { tabNames } from "@/utils/constants/contact.constant";
import TabGeneralInquiry from "@/components/TabGeneralInquiry";
import TabFranchiseOpportunity from "@/components/TabFranchiseOpportunity";
import AppTabs from "@/components/AppTabs";
import MainBanner from "@/components/MainBanner";
import { useIsMounted } from "usehooks-ts";
import pageStructuresApi, {
  IGetPageStructuresResponse,
} from "@/utils/api/pageStructures";
import { useRouter } from "next/router";

export default function ContactUs() {
  const { locale } = useRouter();
  const { classes } = useStyles({ params: { locale: locale! } });

  const [tabIndex, setTabIndex] = useState<number>(0);
  const [pageStructure, setPageStructure] =
    useState<IGetPageStructuresResponse | null>(null);

  let getPageStructure = async () => {
    try {
      let res = await pageStructuresApi.getPageStructures({
        params: {
          page: "CONTACTUS",
        },
        headers: { Language: locale ? locale.replace("-", "_") : undefined },
      });
      if (res.status === 200) {
        setPageStructure(res.data.params);
      }
    } catch (error) {
      console.log(error);
    }
  };

  let handleClickTab = (index: number) => {
    setTabIndex(index);
  };

  let FetchData = async () => {
    await getPageStructure();
  };

  useEffect(() => {
    if (isMounted()) return;
    FetchData();
  }, []);

  useEffect(() => {
    if (!isMounted()) return;
    FetchData();
  }, [locale]);

  const isMounted = useIsMounted();

  return (
    <div>
      {pageStructure && pageStructure.Banners && (
        <MainBanner
          bannerUrl={pageStructure?.Banners.path}
          bannerText={
            <h1 style={{ textAlign: "center" }}>
              {pageStructure.Banners.title}
            </h1>
          }
          smBanner={true}
          video={pageStructure.Banners.path}
          api={pageStructure.Banners.type}
        />
      )}
      <AppContainer>
        <div className={classes.aboutUsPage}>
          <AppTabs tabNames={tabNames} onChange={handleClickTab}></AppTabs>
          <div className={classes.tabContentContainer}>
            {tabIndex === 0 ? (
              <TabGeneralInquiry></TabGeneralInquiry>
            ) : tabIndex === 1 ? (
              <TabFranchiseOpportunity></TabFranchiseOpportunity>
            ) : (
              <></>
            )}
          </div>
        </div>
      </AppContainer>
    </div>
  );
}
